<div class="main-content">
    <div class="game-page" style="position: relative;">
        <!-- Nav tabs -->

        <tabset>
            <tab heading="ODDS">
                <div class="match-title mb-2">
                    <span class="match-name">Multi Market</span>
                </div>

                <div *ngIf="data">
                    <div class="tab-content">
                        <div id="odds" class="tab-pane active">

                            <div class="" *ngFor="let dt of data;let di=index;trackBy:trackByIndex;">

                            
                                <div class="match-title multi-match-title" (click)="detailPage(dt[0])">
                                    <span class="match-name">
                                        {{dt[0]?.event?.name ? dt[0]?.event?.name : dt[0]?.name}}
                                    </span>
                                    <span class="float-right">
                                        <a href="javascript:void(0)" class="UserChipData">
                                            <i class="fa fa-angle-double-right"></i>
                                        </a>
                                    </span>
                                </div>

                                <div class="market" *ngFor="let item of dt;let j=index;trackBy:trackByIndex">

                                    <!-- MATCH_ODDS -->
                                    <div *ngIf="item?.market_id[0] && item?.market_id[0] == '1'">
                                        <app-market-detail
                                            [data]="{marketData: item, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                                            (betDt)="openBetPlace($event)" (updateData)="updateData($event)"
                                            (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)"
                                            (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-market-detail>

                                        <div>
                                        </div>
                                    </div>
                                    <!-- /MATCH_ODDS -->

                                    <!-- BOOKMAKER -->
                                    <div *ngIf="item?.market_id[0] && item?.market_id[0] == '8'">
                                        <div>
                                            <div>
                                                <app-bookmaker-detail
                                                    [data]="{marketData: oddsLisDis[item?.market_id], odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                                                    (betDt)="openBetPlace($event)" (updateData)="updateData($event)"
                                                    (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)"
                                                    (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-bookmaker-detail>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /BOOKMAKER -->

                                    <!-- LINE -->
                                    <div class="fancy-markets mt-1" *ngIf="item?.market_id[0] && item?.market_id[0] == '9'">
                                        <div class="fancy-market">
                                            <div>
                                                <div class="table-header">
                                                    <div class="market-title float-left country-name box-4">
                                                        <span class="text-uppercase mr-1">Fancy</span>
                                                        <p class="float-right mb-0" (click)="openModalWithComponent('f')">
                                                            <i class="fas fa-info-circle"></i>
                                                        </p>
                                                    </div>
                                                    <div class="box-1 float-left lay text-center"><b>No</b></div>
                                                    <div class="back box-1 float-left back text-center"><b>Yes</b></div>
                                                </div>
                                                <app-fancy-detail
                                                    [data]="{fancyData: item?.data, tabVal:item?.allFancy, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, token: token, betSlipData: betSlipData, mmIds: multiMarketIds}"
                                                    (betDt)="openBetPlace($event)" (updateData)="updateData($event)"
                                                    (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)"
                                                    (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /LINE -->
                                
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
                <div *ngIf="data?.length == 0">
                    <div class="market">
                        <h4 class="text-center p-5">There are currently no followed multi markets, please add some markets from events.</h4>
                    </div>
                </div>

                <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>

            </tab>
            <tab heading="MATCHED BET ({{betCount}})">
                <app-m-bet-list *ngIf="isLogin()" (totalBets)="betCount = $event"></app-m-bet-list>
            </tab>
        </tabset>




    </div>
</div>

<div class="modal fade place-bet-modal" bsModal #betSlipModal="bs-modal" [config]="{backdrop: true}" tabindex="-1"
    role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static-name" class="modal-title pull-left">Placebet</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeBet('')">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-m-bet-slip [data]="betSlipData" [exposLisDis]="exposLisDis" (updateData)="updateData($event)"
                    (changeExpo)="changeExpo($event)" (closeBet)="closeBet($event)">
                </app-m-bet-slip>
            </div>
        </div>
    </div>
</div>